<template>
  <b-form @submit="onSubmit">
    <b-form-group
      id="input-group-name"
      label="Nom"
      label-for="input-name">
      <b-form-input
        id="input-name"
        v-model="form.quiz_name"
        type="text"
        placeholder="Exemple : Grands classiques"
        required
      />
    </b-form-group>
    <b-form-group
      id="input-group-category"
      label="Catégorie"
      label-for="input-category">
      <b-form-select
        v-model="form.quiz_category"
        :options="categoriesValues"/>
    </b-form-group>
    <b-form-group
      id="input-group-level"
      label="Niveau de difficulté"
      label-for="input-level">
      <b-form-select
        v-model="form.quiz_level"
        :options="levelValues"/>
    </b-form-group>
    <b-row/>
    <b-row>
      <b-col class="text-center">
        <b-button
          :disabled="pending"
          type="submit"
          variant="primary">
          <span v-if="pending">
            <b-spinner
              small
              variant="light"/>
          </span>
          <span v-else>
            Enregistrer
          </span>
        </b-button>
      </b-col>
    </b-row>

  </b-form>
</template>

<script>
export default {
  name: 'FormQuizSimplified',
  props: {
    quiz: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        quiz_id: null,
        quiz_name: '',
        quiz_level: null,
        quiz_category: null,
      },
      categoriesValues: [{ value: 'art', text: 'Arts et Culture' },
        { value: 'gastronomy', text: 'Gastronomie' },
        { value: 'sport', text: 'Sport et loisirs' },
        { value: 'entertainment', text: 'Divertissement' },
        { value: 'science', text: 'Sciences' },
        { value: 'history', text: 'Histoire' },
        { value: 'geography', text: 'Géographie' }],
      levelValues: [{ value: 1, text: 'Facile' },
        { value: 2, text: 'Moyen' },
        { value: 3, text: 'Difficile' },
        { value: 4, text: 'Expert' }],
      pending: false,
    };
  },
  watch: {

  },
  mounted() {
    this.form.quiz_id = this.quiz.dmo_id;
    this.form.quiz_name = this.quiz.dmo_data.title;
    this.form.quiz_level = this.quiz.dmo_data.level;
    this.form.quiz_category = this.quiz.dmo_data.category;
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$store.dispatch('modules/updateMiniQuiz', this.form).then(() => {
        this.$emit('quizUpdated');
        this.pending = false;
      });
    },
  },
};
</script>

<style scoped>
.form_questions {
  padding: 10px;
  background-color: aliceblue;
  border-radius: 10px;
  border: 1px solid rgb(0 123 255 / 50%);
  margin: 10px 0;
}
</style>
